import React from 'react';
import { Checkbox, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SalovareSelectField from '../common/SalovareSelectField';

const ALL_OPTION = '__all__';

const DashboardTeamMemberFilter = ({ label, teamMembers, value, onChange }) => {
  const { t } = useTranslation();
  const selectedIds = value ?? [];
  const isAll = value === null || value === undefined;

  const handleChange = (event) => {
    const next = event.target.value;

    if (next.includes(ALL_OPTION) || next.length === 0 || next.length === teamMembers.length) {
      onChange(null);
      return;
    }

    onChange(next);
  };

  const renderValue = (selected) => {
    if (isAll || selected.length === 0) return t('dashboard.filters.allProfessionals');

    return teamMembers
      .filter((member) => selected.includes(member.id))
      .map((member) => member.name)
      .join(', ');
  };

  return (
    <SalovareSelectField
      label={label}
      multiple
      displayEmpty
      value={selectedIds}
      onChange={handleChange}
      renderValue={renderValue}
    >
      <MenuItem value={ALL_OPTION}>
        <Checkbox checked={isAll} size="small" />
        <ListItemText primary={t('dashboard.filters.allProfessionals')} />
      </MenuItem>
      {teamMembers.map((member) => (
        <MenuItem key={member.id} value={member.id}>
          <Checkbox checked={selectedIds.includes(member.id)} size="small" />
          <ListItemText primary={member.name} />
        </MenuItem>
      ))}
    </SalovareSelectField>
  );
};

export default DashboardTeamMemberFilter;
